let defaultState = {
  data: {},
  campaign_aggs: null,
  offices_aggs: null,
  shifts_aggs: null,
  routes_aggs: null,
  canvassers_aggs: null,
  last_update: null,
  loading: false,
  error: false,
};

const aggregates = function (state = defaultState, action) {
  switch (action.type) {
    case "CLEAR_CAMPAIGN_AGG_CACHE":
      return { ...defaultState };

    case "UPDATE_AGG_DATA":
      return { ...state, data: { ...action.data }, last_update: Date.now() };

    case "SET_CAMPAIGN_SUBAGGS":
      const st = { ...state };
      st[action.ctx] = action.rows;
      st.last_update = Date.now();
      return st;

    case "SET_AGGREGATES_LOADING":
      return { ...state, loading: action.data };

    case "SET_AGGREGATES_ERROR":
      return { ...state, error: action.data };

    default:
      return state;
  }
};

export default aggregates;
